module.exports = __webpack_public_path__ + "img/2024-02-13e_4.331893b8.jpg";